import React from 'react';

class ClosureModal extends React.Component {
    render() {
        const { CommentCloseDoc, ChangeCommentCloseDoc, BranchOfficeGeneralCut} = this.props
        return (
            <div className="modal fade" id="closureModal" tabIndex="-1" role="dialog" aria-labelledby="closureModalTitle" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <h4>¿Realizar cierre del dia y generar documentos globales?</h4>
                            <div id="grupo__commentClosure">
                                <div className="input-group mt-4 mb-2">
                                    <input
                                        type='text'
                                        className="form-control form__input"
                                        aria-label="With textarea"
                                        placeholder="Comentarios"
                                        value={CommentCloseDoc}
                                        onChange={(event) => ChangeCommentCloseDoc(event.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" data-toggle="modal" /*data-target="#consolidateDocsModal"*/>Cancelar</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={BranchOfficeGeneralCut}>Realizar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ClosureModal

